import React from "react";

import AppLogoStepOne from "img/how-to-img/app-logo.png";
import PackageStepTwo from "img/how-to-img/product-package.png";
import ChatStepThree from "img/how-to-img/chat-driver.png";
import MessageStepFour from "img/how-to-img/message.png";
import DropOffStepFive from "img/how-to-img/drop-off.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
        <h1 className="small-heading">Steps to Communicate with Driver</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={AppLogoStepOne}
            alt="Step One"
            style={{ width: "320px" }}
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Open the Trippie Air App
          </h1>
          <p className="small-para">
            Launch the Trippie Air mobile app on your device. Make sure you're logged in with your registered account to access your delivery dashboard.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PackageStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Go to 'My Deliveries'
          </h1>
          <p className="small-para">
            From the home screen or bottom navigation bar, tap on "My Deliveries" to view all your active and past deliveries. Select the one you want to manage or track.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ChatStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Tap on 'Chat with Driver'
          </h1>
          <p className="small-para">
            In the delivery details page, tap "Chat with Driver." This opens a secure messaging window where you can communicate directly with the assigned courier.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={MessageStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Send Instructions or Updates
          </h1>
          <p className="small-para">
            Use the chat to share any special instructions — for example: "Please leave the package at the reception" or "Call me if no one answers."
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={DropOffStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Enable Contactless Drop-off
          </h1>
          <p className="small-para">
            If you won't be available to receive the package, you can convert your QR code into a secure numeric code within the app chat. Share this code with the driver through chat — they'll enter it on their device to confirm secure delivery without needing face-to-face interaction.
          </p>
        </div>
      </div>
    </div>
  );
}